'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

var _fetchJsonp = require('fetch-jsonp');

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var request = new _request2['default']();
request.jsonp = _fetchJsonp2['default'];

if (typeof window.fetch === 'undefined') {
  require('whatwg-fetch');
}

// singleton
exports['default'] = request;
module.exports = exports['default'];